import React from "react";
import { Linkedin } from "lucide-react";
const Footer = () => {
  return <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo */}
          <div>
            <img src="/lovable-uploads/0174e7d3-9a04-4db3-b808-8ef7469fc5a8.png" alt="Naboo" width="104" height="32" className="h-8" onError={e => {
            console.warn("Impossible de charger le logo du pied de page");
            e.currentTarget.style.display = 'none';
          }} />
          </div>
          
          {/* Liens légaux */}
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-sm">
            <span className="font-normal">© SAS NABOO GROUP 2026</span>
            <a href="https://www.naboo.app/en-us/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
              Mentions légales & Politique de confidentialité
            </a>
            <a href="https://www.naboo.app/en-us/terms-of-use" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
              Conditions générales d'utilisation
            </a>
            <a href="javascript:openAxeptioCookies()" className="text-sm leading-5 antialiased whitespace-nowrap inline-block text-white hover:text-gray-300 transition-colors hover:underline underline-offset-2 cursor-pointer">
              Mes préférences cookies
            </a>
          </div>
          
          {/* Social */}
          <div>
            <a href="https://www.linkedin.com/company/naboo-app" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="LinkedIn">
              <Linkedin className="h-5 w-5 text-white fill-current" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;